var amdi18n={};amdi18n.init=function (language){
    if(!language){
        if(window._i18n && window._i18n.locale){
            language = window._i18n.locale;
        }else{
            language = 'root';
        }
    }
    Object.assign(this,this.__root,this['__'+language]);
  };amdi18n.init();module.exports=amdi18n;


/*****************
 ** WEBPACK FOOTER
 ** ./~/amdi18n-loader!./galaxy/scripts/nls/locale.js
 ** module id = 154
 ** module chunks = 2
 **/